export default {
  contact: {
    sk: 'Kontakt',
    en: 'Contact',
  },
  projects: {
    sk: 'Projekty',
    en: 'Projects',
  },
  approach: {
    sk: 'Prístup',
    en: 'Approach',
  },
  index: {
    sk: 'Domov',
    en: 'Home',
  },
  studio: {
    sk: 'Štúdio',
    en: 'Studio',
  },
  blog: {
    sk: 'Blog',
    en: 'Blog',
  },
  insights: {
    sk: 'Blog',
    en: 'Insights',
  },
  services: {
    sk: 'Služby',
    en: 'Services',
  },
};



// WEBPACK FOOTER //
// ./src/modules/Menu/messages.js